angular.module('SpidApp')

.factory('StampDirectAccessService', ['SyncConfig', '$http', function (SyncConfig, $http) {
    var StampDirectAccessService = {
        _forgeURL: function (code_affranchissement, code_destination, poids, options, services) {
            // Example: 
            // /stamps/ws/ENV007/EDS0083/20/EOP08
            
            var args = [
                  '/stamps/ws/'
                , code_affranchissement
                , '/'
                , code_destination
                , '/'
                , poids
                , '/'
                , options.join('-')
                , '/'
                , services.join('-')
            ].join('')
            
            return SyncConfig.Distant.getURLFor(args)
        },
        getPrice: function (code_affranchissement, code_destination, poids, options, services) {
            options  = options  || []
            services = services || []
            
            if (  !code_affranchissement || !code_destination || !poids) {
                throw 'StampDirectAccessService::getPrice() - Missing parameters'
            }
            
            var distantAuthorization = SyncConfig.Distant.Authorization
            var distantURL = this._forgeURL(code_affranchissement, code_destination, poids, options, services)
            var req = { method: 'GET', url: distantURL, headers: { 'Authorization': distantAuthorization } }
            
            return $http(req).then(function (response) {
                return response
            })
        }
    }
    
    return StampDirectAccessService
}])
